import React from 'react'

// Desert Flora inline-SVG glyphs (24×24 viewBox, 1.8px round stroke, currentColor).
// The design system's Icon set isn't bundled with the handoff, so we recreate the
// four glyphs the AR aging dashboard uses: search, alert, chevron-up, chevron-down.
const Svg = ({ size = 24, children }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
)

export const IconSearch = (props) => (
  <Svg {...props}>
    <circle cx="11" cy="11" r="7" />
    <line x1="16.5" y1="16.5" x2="21" y2="21" />
  </Svg>
)

export const IconAlert = (props) => (
  <Svg {...props}>
    <path d="M12 3 2.5 20h19L12 3Z" />
    <line x1="12" y1="10" x2="12" y2="14" />
    <line x1="12" y1="17" x2="12" y2="17" />
  </Svg>
)

export const IconChevronUp = (props) => (
  <Svg {...props}>
    <polyline points="6 15 12 9 18 15" />
  </Svg>
)

export const IconChevronDown = (props) => (
  <Svg {...props}>
    <polyline points="6 9 12 15 18 9" />
  </Svg>
)
